module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../images/info.03dd8cd9.svg";